import { getIdioma } from "@/lib/i18n";

const TZ = "America/Chicago";

export function hoyChicago() {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return fmt.format(new Date());
}

// Formatea un datetime ISO (UTC) a hora Chicago 12h: "2:35 PM"
export function formatHora(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
}

// Formatea un datetime ISO (UTC) a fecha Chicago: "jue 1 oct"
export function formatFechaIso(iso) {
  if (!iso) return "—";
  return fechaCorta(new Date(iso), TZ);
}

// Formatea "YYYY-MM-DD" (día de trabajo) a "jue 1 oct"
export function formatFecha(ymd) {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d, 12));
  return fechaCorta(dt, "UTC");
}

function fechaCorta(dt, tz) {
  const es = getIdioma() === "es";
  const loc = es ? "es" : "en-US";
  const wd = new Intl.DateTimeFormat(loc, { weekday: "short", timeZone: tz }).format(dt).replace(".", "");
  const day = new Intl.DateTimeFormat(loc, { day: "numeric", timeZone: tz }).format(dt);
  const mo = new Intl.DateTimeFormat(loc, { month: "short", timeZone: tz }).format(dt).replace(".", "");
  return es ? `${wd} ${day} ${mo}` : `${wd} ${mo} ${day}`;
}

// Formatea "HH:MM" a "2:35 PM"
export function formatHoraInicio(hhmm) {
  if (!hhmm) return "—";
  const [h, m] = hhmm.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
}

export function fechaHoraCompleta(iso) {
  if (!iso) return "—";
  return `${formatFechaIso(iso)}, ${formatHora(iso)}`;
}

// Fix P (2026-10-13): fecha y hora en la zona horaria de la etapa, con su sigla: «mar 13 oct · 8:00 AM CT».
const SIGLA_ZONA = { "America/Chicago": "CT", "America/New_York": "ET", "America/Denver": "MT", "America/Los_Angeles": "PT" };

export function siglaZona(zona) {
  return SIGLA_ZONA[zona] || "CT";
}

export function formatFechaHoraZona(iso, zona) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const tz = SIGLA_ZONA[zona] ? zona : TZ;
  const hora = new Intl.DateTimeFormat("en-US", { timeZone: tz, hour: "numeric", minute: "2-digit", hour12: true }).format(d);
  return `${fechaCorta(d, tz)} · ${hora} ${siglaZona(tz)}`;
}

// Fecha y hora que ya están en la hora de pared de la zona (la ETA que cargó el chofer): «mar 13 oct · 9:45 AM CT».
export function formatFechaHoraPared(ymd, hhmm, zona) {
  if (!ymd) return "—";
  return `${formatFecha(ymd)}${hhmm ? ` · ${formatHoraInicio(hhmm)}` : ""} ${siglaZona(zona)}`;
}

// Convierte una hora de pared (HH:MM) del día de hoy en Chicago a un instante UTC (ISO).
export function choferTimeToUTC(ymd, hhmm) {
  const [Y, M, D] = ymd.split("-").map(Number);
  const [h, mi] = hhmm.split(":").map(Number);
  const utcGuess = new Date(Date.UTC(Y, M - 1, D, h, mi));
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  }).formatToParts(utcGuess);
  const get = (t) => Number(parts.find((p) => p.type === t).value);
  let hour = get("hour");
  if (hour === 24) hour = 0;
  const chicagoAsUTC = Date.UTC(get("year"), get("month") - 1, get("day"), hour, get("minute"));
  const offset = chicagoAsUTC - utcGuess.getTime();
  return new Date(utcGuess.getTime() - offset).toISOString();
}
